// Counts set_planner_filters runs; the planner top menu watches it to redraw for the new selection.
export default (state = 0, action) => {
    switch (action.type) {
        case 'HUNT_PLANNER_ARTEMIS_APPLIED':
            return state + 1
        case 'LOGOUT':
            return 0
        default:
            return state
    }
}
